// extracted by mini-css-extract-plugin
export default {"icon":"StatusModal_icon__iB2u1","checkmark":"StatusModal_checkmark__iVM+E","xmark":"StatusModal_xmark__FBRJ6","submitText":"StatusModal_submitText__mHNE3"};